module.exports = __webpack_public_path__ + "img/second.862d7fbb.png";